
<a :href="url" class="d-flex align-items-center">{{ title }}</a>
